import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FacebookIcon, 
  TwitterIcon, 
  WhatsAppIcon, 
  EmailIcon 
} from '../icons/SocialIcons';
import TermsOfService from '../modals/TermsOfService';
import PrivacyPolicy from '../modals/PrivacyPolicy';

const Footer: React.FC = () => {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  
  return (
    <footer className="mobile-optimized-footer">
      <div className="footer-content">
        <div className="footer-column">
          <h3 className="footer-title">KNOW</h3>
          <p className="footer-text">
            Test your biblical knowledge and grow in faith with our interactive
            and educational Bible trivia game designed for all ages.
          </p>
          <div className="footer-social">
            <a href="https://wa.me/?text=Test%20your%20Bible%20knowledge%20with%20KNOW%2C%20an%20engaging%20trivia%20game!" 
               className="social-icon"
               target="_blank"
               rel="noopener noreferrer"
               aria-label="WhatsApp"
            >
              <WhatsAppIcon size={20} color="currentColor" />
            </a>
            <a href="mailto:?subject=Check%20out%20this%20Bible%20Trivia%20Game&body=I%20thought%20you%20might%20enjoy%20this%20Bible%20trivia%20game%20called%20KNOW!" 
               className="social-icon"
               aria-label="Email"
            >
              <EmailIcon size={20} color="currentColor" />
            </a>
            <a href="https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fknow-bible.com" 
               className="social-icon"
               target="_blank"
               rel="noopener noreferrer"
               aria-label="Facebook"
            >
              <FacebookIcon size={20} color="currentColor" />
            </a>
            <a href="https://twitter.com/intent/tweet?text=Test%20your%20Bible%20knowledge%20with%20KNOW%2C%20an%20engaging%20trivia%20game!" 
               className="social-icon"
               target="_blank"
               rel="noopener noreferrer"
               aria-label="Twitter"
            >
              <TwitterIcon size={20} color="currentColor" />
            </a>
          </div>
        </div>
        
        <div className="footer-column">
          <h3 className="footer-title">Quick Links</h3>
          <div className="footer-links">
            <Link to="/" className="footer-link">Home</Link>
            <Link to="/about" className="footer-link">About</Link>
            <Link to="/leaderboard" className="footer-link">Leaderboard</Link>
            <Link to="/play" className="footer-link">Play Now</Link>
          </div>
        </div>
        
        <div className="footer-column">
          <h3 className="footer-title">Resources</h3>
          <div className="footer-links">
            <a href="https://www.biblestudytools.com/" target="_blank" rel="noopener noreferrer" className="footer-link">Bible Study Tools</a>
            <a href="https://www.bible.com/verse-of-the-day" target="_blank" rel="noopener noreferrer" className="footer-link">Verse of the Day</a>
            <a href="https://www.biblechartsandmaps.com/product/amazing-bible-timeline-with-bonuses/" target="_blank" rel="noopener noreferrer" className="footer-link">Bible Timeline</a>
            <a href="https://bible-history.com/maps/" target="_blank" rel="noopener noreferrer" className="footer-link">Biblical Maps</a>
          </div>
        </div>
        
        <div className="footer-column">
          <h3 className="footer-title">Contact Us</h3>
          <div className="footer-links">
            <a href="mailto:emraaysocials@gmail.com" className="footer-link">emraaysocials@gmail.com</a>
            <a href="tel:+14165557890" className="footer-link">+1 (416) 555-7890</a>
            <p className="footer-text">150 King Street West<br />Toronto, ON M5H 1J9<br />Canada</p>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p className="copyright-text">&copy; {new Date().getFullYear()} KNOW - Bible Trivia Game | All Rights Reserved</p>
        <p className="emraay-credit">
          Powered by <a href="https://emraaysolutions.com/" target="_blank" rel="noopener noreferrer" className="emraay-link">Emraay Solutions</a>
        </p>
        <div className="footer-legal-links">
          <button 
            onClick={() => setShowTerms(true)} 
            className="footer-link-btn"
          >
            Terms of Service
          </button>
          <button 
            onClick={() => setShowPrivacy(true)} 
            className="footer-link-btn"
          >
            Privacy Policy
          </button>
        </div>
        
        {/* Modals */}
        <TermsOfService isOpen={showTerms} onClose={() => setShowTerms(false)} />
        <PrivacyPolicy isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} />
      </div>
    </footer>
  );
};

export default Footer;